import { StyleSheet, Platform, Dimensions } from 'react-native';

import { isIPhoneDeviceWithNotch } from '../../Utils/Platform';
import { Fonts } from '../Themes';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();
export const getTop = () => {
  if (isIPhoneWithNotch) {
    return 33.5;
  }
  if (Platform.OS === 'ios') {
    return 19.5;
  }
  return 3.5;
};

export default StyleSheet.create({
  containerStyle: (theme, configureHeaderTabs) => ({
    backgroundColor: theme.colors.tintColor,
    borderBottomWidth: configureHeaderTabs?.tabs ? 0.3 : 1.1,
    borderBottomColor: theme.colors.borderColorThree,
    position: 'absolute',
    cursor: 'pointer',
    zIndex: 11,
    ...Platform.select({
      web: {
        position: 'initial'
      },
      default: {
      }
    }),
    width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? Dimensions.get('window').width - 300 : Dimensions.get('window').width,
  }),
  iconContainerStyle: {
    width: 25.2,
    zIndex: 1,
    cursor: 'pointer'
  },
  shareButtonContainer: {
    position: 'absolute',
    right: 60,
    top: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 50 : 36) : 20,
  },
  headerContainerStyle: {
    paddingTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 24 : 0,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 24 : 0
  },
  headerStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 57,
    flex: 1,
  },
  headerTextStyle: theme => ({
    color: theme.colors.headerColor,
    fontSize: 24,
    lineHeight: 20,
    letterSpacing: 0,
    marginBottom: 2,
    textAlign: 'center',
    fontWeight: 400
  }),
  subHeaderContainerStyle: (configureHeaderTabs, subHeaderHeightInterpolated) => ({
    paddingHorizontal: 16.4,
    overflow: 'hidden',
    paddingBottom: configureHeaderTabs ? null : 17,
    height: configureHeaderTabs ? subHeaderHeightInterpolated : null,
    marginRight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 8 : null,
  }),
  subHeaderTitleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24,
    lineHeight: 32,
    color: theme.colors.headerColor,
  }),
  subHeaderTitleContainerStyle: {
    marginBottom: 10,
  },
  subTitleSubHeaderAndRightComponentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  subHeaderRightComponent: {
    justifyContent: 'center',
  },
  subHeaderDescription: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 14,
  },
  subHeaderSubTitleViewStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginTop: -10,
  },
  subHeaderSubTitleMainText: theme => ({
    ...Fonts.type.bold,
    fontSize: 24,
    lineHeight: 32,
    color: theme.colors.headerColor,
  }),
  subHeaderSubTitleSecondaryText: theme => ({
    fontSize: 18,
    lineHeight: Platform.OS === 'ios' ? 22 : 28,
    color: theme.colors.headerColor,
  }),
  subHeaderDescriptionMainText: theme => ({
    fontSize: 16,
    lineHeight: 20,
    color: theme.colors.subtitle,
  }),
  subHeaderDescriptionTouchableOpacity: {
    flex: 1,
    marginRight: '5%',
  },
  tabContainerStyle: {
    borderTopWidth: 1,
  },
  errorShimmerViewStyle: {
    maxWidth: '60%',
    marginBottom: 10,
    marginTop: 2,
  },
  subtitleHeaderErrorTryAgainStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: -5,
    marginBottom: 10,
  },
  subHeaderErrorTitleStyle: {
    margin: 5,
    marginBottom: 0,
  },
});
